import { useMemo } from 'react';
import { useI18n } from '../../i18n/I18nContext';
import { app as enApp } from '../../i18n/locales/app/en';
import type {
  AppAdminUsersMessages,
  AppClientsMessages,
  AppInvoicesTableMessages,
  AppTableMessages,
} from '../../i18n/types';

/**
 * Libellés des vues "table" (Notion-like) avec repli sur l'anglais :
 * les sections `table`, `clients` et `invoicesTable` sont optionnelles dans
 * les locales pour ne pas bloquer les traductions en cours.
 */
export const useNotionMessages = () => {
  const { t, locale } = useI18n();
  return useMemo(
    () => ({
      locale,
      table: (t.app.table || enApp.table) as AppTableMessages,
      clients: (t.app.clients || enApp.clients) as AppClientsMessages,
      invoicesTable: (t.app.invoicesTable || enApp.invoicesTable) as AppInvoicesTableMessages,
      adminUsers: (t.app.adminUsers || enApp.adminUsers) as AppAdminUsersMessages,
      clientsMenuLabel: t.app.layout.clients || enApp.layout.clients || 'Clients',
    }),
    [t, locale],
  );
};

export default useNotionMessages;
